import React, { Component } from 'react'
import { Modal, Input, Select, message } from 'hljd'
import style from './style.module.less'
import Chat from '@common/Chat'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import cls from 'classnames'
import FollowModal from './FollowModal'
import CollaborateModal from './CollaborateModal'
import { isExperienceStore } from '@util'
import { CONTACT_MOBILE, CONTACT_ARRI } from '../../constant'
import { dGet } from '@core/utils'

const Option = Select.Option
const TestArea = Input.TextArea

@observer
class BasicInfo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      selectValue: '',
      des: '',
      support: ''
    }
  }

  handleOk = () => {
    const { selectValue, des, support } = this.state
    if (!selectValue) {
      return message.warning('请选择转移员工')
    }
    if (!des) {
      return message.warning('请填写备注')
    }
    const { store } = this.props
    const supportList = toJS(store.supportList)

    store.changeMerchant(
      {
        merchant_support_id: selectValue,
        remark: des
      },
      supportList.channel_id,
      { merchant_support_user_id: Number(support) }
    )
    this.handleCancel()
  }
  handleCancel = () => {
    this.setState({
      visible: false,
      selectValue: '',
      des: '',
      support: ''
    })
  }

  onShow = () => {
    this.setState({
      visible: true
    })
    this.props.store.getSupportList(this.props.id)
  }

  getActions = () => {
    const { openOrCloseContactModal } = this.props.store
    const isExperience = isExperienceStore()
    return [
      {
        id: 1,
        title: '联系',
        icon: '//qnm.hunliji.com/o_1d8no46qp7oj9u11nfoo8kfd9d.png',
        onClick: () => openOrCloseContactModal(true, CONTACT_MOBILE)
      },
      {
        id: 2,
        title: '到店',
        icon: '//qnm.hunliji.com/o_1d8no46qp1b60163plqpmpnoaje.png',
        onClick: () => openOrCloseContactModal(true, CONTACT_ARRI)
      },
      {
        id: 3,
        title: '签单',
        icon: '//qnm.hunliji.com/o_1d8no46qpjake5o1nv4ti617igf.png',
        onClick: () => {
          if (isExperience) {
            this.props.store.setStoreData([
              {
                type: 'insertCoopOrderModalVisible',
                value: true
              }
            ])
          } else {
            this.props.store.setStoreData([
              {
                type: 'signModalVisible',
                value: true
              }
            ])
          }
        }
      },
      {
        id: 4,
        title: '任务',
        icon: '//qnm.hunliji.com/o_1d8no46qpgtg1obo13cd1nl31i9g.png',
        onClick: () =>
          this.props.store.setStoreData([
            {
              type: 'taskModalVisible',
              value: true
            }
          ])
      },
      {
        id: 5,
        title: isExperience ? '移交' : '协作',
        icon: '//qnm.hunliji.com/o_1d8no46qpcdf29hoeu1kr91kirh.png',
        onClick: () => {
          if (isExperience) {
            this.onShow()
          } else {
            this.props.store.collaborateModalStore.setStoreData({
              visible: true,
              selected:
                dGet(this.props.store, 'detailData.merchant_support') || []
            })
          }
        }
      }
    ]
  }

  render() {
    const { visible, selectValue, des, support } = this.state
    const { detailData = {}, store } = this.props
    let { user, merchant_support, user_id, gender, channel_id } = detailData
    user = user || {}
    merchant_support = merchant_support || {}
    const staffList = toJS(store.staffList)
    const supportList = toJS(store.supportList)
    const { isNotFollow } = store

    return (
      <>
        <div className={style.wrapper}>
          <div className={style['basic-info']}>
            <img
              src={
                user.avatar ||
                '//qnm.hunliji.com/o_1d1g0i1o84t319ks1fch68v10k89.png'
              }
            />
            <i
              className={cls(
                'icon',
                'iconfont',
                style['sex-icon'],
                `${gender == 1 ? 'icon-nan' : gender == 2 ? 'icon-nv' : ''}`
              )}
            />
            <div className={style.info}>
              <div className={cls(style.name, 'clearfix')}>
                <span>{detailData.user_name || detailData.nick || ''}</span>
                {channel_id > 0 && (
                  <Chat toUserId={user_id || ''}>
                    <i className={`${style['icon']} iconfont icon-sixin`} />
                  </Chat>
                )}

                <span
                  className={`fr ${style['move']}`}
                  onClick={() =>
                    store.followModalStore.setStoreData({
                      followModalVisible: true
                    })
                  }
                >
                  {isNotFollow ? '重新跟进' : '不再跟进'}
                </span>
              </div>
              <div className={style.other}>
                <span>来源&nbsp;:&nbsp;</span>
                <span>{detailData.source_name}</span>
              </div>
            </div>
          </div>

          <div className={style.actions}>
            {this.getActions().map(({ id, title, icon, onClick }) => {
              return (
                <div key={id} className={style.action} onClick={onClick}>
                  <img src={icon} />
                  <div style={{ marginTop: 6, color: '#333' }}>{title}</div>
                </div>
              )
            })}
          </div>
        </div>

        <Modal
          title={`移交 ${detailData.user_name ||
            detailData.nick ||
            ''} 给其他员工`}
          visible={visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          width={400}
          wrapClassName={style['move-staff-wrap']}
        >
          <p style={{ marginBottom: '10px' }}>注意事项：</p>
          <p>1.除非是超级管理员，移交成功后将不能再看到此客户</p>
          <p style={{ marginBottom: '20px' }}>
            2.支持移交给超级管理员、具有客服权限的员工
          </p>
          <div className={style.item}>
            <span className={style.label}>转移给&nbsp;:&nbsp;</span>
            <Select
              className={style['flex-1']}
              vlaue={selectValue}
              onChange={selectValue => this.setState({ selectValue })}
            >
              {staffList.map(item => {
                const disabledId = merchant_support.id || ''
                return (
                  <Option
                    value={item.id}
                    key={item.id}
                    disabled={disabledId === item.id}
                  >
                    <div className="clearfix">
                      <span>
                        {item.nick}
                        {disabledId === item.id ? '  (当前归属人)' : ''}
                      </span>
                      <span className="fr">
                        {item.is_admin == 1 ? '超管' : '客服'}
                      </span>
                    </div>
                  </Option>
                )
              })}
            </Select>
          </div>
          <div className={style.item}>
            <span className={style.label}>备注&nbsp;:&nbsp;</span>
            <TestArea
              className={style['flex-1']}
              rows={3}
              value={des}
              onChange={e => this.setState({ des: e.target.value })}
            />
          </div>
          {channel_id &&
            channel_id != 0 && (
              <div>
                <p style={{ padding: '8px 0 12px 0' }}>
                  当前客户私信处理人：{supportList.chat_support
                    ? supportList.chat_support.nick
                    : ''}
                </p>
                <div className={style.item} style={{ marginBottom: 0 }}>
                  <span className={style.label1}>私信转移给&nbsp;:&nbsp;</span>
                  <Select
                    className={style['flex-1']}
                    placeholder="请选择"
                    value={support}
                    onChange={value => this.setState({ support: value })}
                  >
                    {supportList.chat_support_list &&
                      supportList.chat_support_list.map((item, index) => {
                        return (
                          <Option key={index} value={item.user_id}>
                            {item.nick}
                          </Option>
                        )
                      })}
                  </Select>
                  <span style={{ width: '88px', marginLeft: '8px' }}>
                    此人必须在线
                  </span>
                </div>
              </div>
            )}
        </Modal>

        <FollowModal />
        <CollaborateModal />
      </>
    )
  }
}

export default BasicInfo
